import { Button } from "../ui/button";
import { ComplexityChip } from "./ShelfChips";
import { Clock, User, CalendarDays, Hand } from "lucide-react";

export const ShelfCard = ({ item, canClaim, claiming, onClaim, onOpen }) => {
  const due = item.days_until_due;
  const dueTone = due === null ? "" : due < 0 ? "text-rose-600" : due <= 14 ? "text-amber-600" : "text-muted-foreground";

  return (
    <div
      role="button"
      tabIndex={0}
      onClick={() => onOpen(item)}
      onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && onOpen(item)}
      className="group relative flex flex-col gap-3 p-5 bg-card border border-border rounded-xl shadow-sm cursor-pointer hover:shadow-md hover:-translate-y-0.5 hover:border-primary/40 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/50 transition-[transform,box-shadow,border-color] duration-200"
      data-testid={`shelf-card-${item.id}`}
    >
      <div className="space-y-2">
        <h3 className="text-base font-semibold text-foreground tracking-tight leading-snug break-words">
          {item.client_id && (
            <span className="font-mono text-muted-foreground mr-2">{item.client_id}</span>
          )}
          {item.client_name}
        </h3>
        <div className="flex items-center gap-2 flex-wrap">
          <p className="text-xs text-muted-foreground font-mono">{item.work_label}</p>
          <ComplexityChip value={item.complexity} />
        </div>
      </div>

      <div className="space-y-1.5 text-xs">
        <div className="flex items-center gap-1.5 text-muted-foreground">
          <Clock size={12} />
          <span className="tabular-nums">{item.days_on_shelf}d on shelf</span>
        </div>
        {item.due_date && (
          <div className={`flex items-center gap-1.5 ${dueTone}`}>
            <CalendarDays size={12} />
            <span className="tabular-nums">
              Due {item.due_date}
              {due !== null && (due < 0 ? ` (${Math.abs(due)}d late)` : ` (${due}d)`)}
            </span>
          </div>
        )}
        {item.created_by && (
          <div className="flex items-center gap-1.5 text-muted-foreground">
            <User size={12} />
            <span className="break-words">Put up by {item.created_by}</span>
          </div>
        )}
      </div>

      <Button
        className="w-full mt-auto gap-2"
        disabled={!canClaim || claiming}
        onClick={(e) => {
          e.stopPropagation();
          onClaim(item);
        }}
        data-testid={`claim-btn-${item.id}`}
      >
        <Hand size={15} />
        {claiming ? "Claiming…" : "Claim"}
      </Button>
    </div>
  );
};
